<template>
  <b-card no-body>
    <b-card-header class="d-flex justify-content-between align-items-center flex-wrap">
      <b-card-title class="mb-0">
        증권회사
      </b-card-title>
      <div class="d-flex align-items-center">
        <b-button
          variant="outline-primary"
          class="mr-1"
          :disabled="loading || syncing"
          @click="fetchList"
        >
          목록조회
        </b-button>
        <b-button
          variant="primary"
          :disabled="loading || syncing"
          @click="syncFromKiwoom"
        >
          <b-spinner
            v-if="syncing"
            small
            class="mr-50"
          />
          동기화
        </b-button>
      </div>
    </b-card-header>

    <b-card-body>
      <b-alert
        v-if="errorMessage"
        variant="danger"
        show
      >
        {{ errorMessage }}
      </b-alert>

      <b-alert
        v-if="syncResult"
        variant="success"
        show
      >
        동기화 완료: 요청 {{ syncResult.requestCount }}건, 저장 {{ syncResult.savedCount }}건
      </b-alert>

      <b-input-group class="mb-1">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" size="14" />
        </b-input-group-prepend>
        <b-form-input
          v-model="keyword"
          placeholder="코드/증권회사명 검색"
          @keyup.enter="search"
        />
        <b-input-group-append>
          <b-button
            variant="outline-secondary"
            :disabled="loading"
            @click="search"
          >
            검색
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-table
        :items="items"
        :fields="fields"
        responsive
        small
        show-empty
        empty-text="조회된 증권회사가 없습니다."
        :busy="loading"
      >
        <template #cell(gb)="row">
          <b-badge
            v-if="row.item.gb"
            variant="light-primary"
          >
            {{ row.item.gb }}
          </b-badge>
          <span v-else>-</span>
        </template>
      </b-table>

      <div class="d-flex align-items-center justify-content-between mt-1">
        <div class="d-flex align-items-center">
          <span class="mr-50">페이지당</span>
          <b-form-select
            v-model="size"
            :options="sizeOptions"
            size="sm"
            style="width: 90px;"
          />
          <span class="ml-50">건</span>
        </div>
        <b-pagination
          v-model="page"
          :total-rows="totalElements"
          :per-page="size"
          first-number
          last-number
          align="right"
          size="sm"
          class="mb-0"
        />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from '@axios'
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BPagination,
  BFormSelect,
  BSpinner,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BFormInput,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BPagination,
    BSpinner,
    BTable,
  },
  data() {
    return {
      loading: false,
      syncing: false,
      page: 1,
      size: 20,
      sizeOptions: [20, 50, 100],
      totalElements: 0,
      keyword: '',
      errorMessage: '',
      syncResult: null,
      items: [],
      fields: [
        { key: 'code', label: '코드' },
        { key: 'name', label: '증권회사명' },
        { key: 'gb', label: '구분' },
      ],
    }
  },
  watch: {
    page() {
      this.fetchList()
    },
    size() {
      this.page = 1
      this.fetchList()
    },
  },
  created() {
    this.fetchList()
  },
  methods: {
    parseApiResponse(response) {
      const payload = response && response.data ? response.data : null
      if (!payload || payload.success !== true) {
        throw new Error(payload && payload.error ? payload.error : '요청 처리 중 오류가 발생했습니다.')
      }
      return payload.data
    },
    async fetchList() {
      this.loading = true
      this.errorMessage = ''
      try {
        const response = await axios.post('/api/kiwoom/company/list', {
          page: this.page,
          size: this.size,
          keyword: this.keyword,
        })
        const data = this.parseApiResponse(response)
        this.items = Array.isArray(data.content) ? data.content : []
        this.totalElements = data.totalElements || 0
      } catch (error) {
        this.errorMessage = error && error.message ? error.message : '증권회사 목록 조회에 실패했습니다.'
      } finally {
        this.loading = false
      }
    },
    async syncFromKiwoom() {
      this.syncing = true
      this.errorMessage = ''
      try {
        const response = await axios.post('/api/kiwoom/company/sync')
        this.syncResult = this.parseApiResponse(response)
        this.page = 1
        await this.fetchList()
      } catch (error) {
        this.errorMessage = error && error.message ? error.message : '증권회사 동기화에 실패했습니다.'
      } finally {
        this.syncing = false
      }
    },
    search() {
      this.page = 1
      this.fetchList()
    },
  },
}
</script>
